import { ReactNode } from 'react';

type ServiceSchedulerDrawerProps = {
  children: ReactNode;
  side?: 'left' | 'right';
};

export function ServiceSchedulerDrawer({
  children,
  side = 'left',
}: ServiceSchedulerDrawerProps) {
  return (
    <aside
      className={`hidden w-80 shrink-0 flex-col items-stretch gap-3 bg-gray-50/40 px-3 py-3 md:flex ${
        side === 'right'
          ? 'border-l border-gray-200'
          : 'border-r border-gray-200'
      }`}
    >
      {children}
    </aside>
  );
}
